import Home from "@src/templates/home";

export default Home;
